
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import { getSwarmSubscriptionRequestRegions } from "../../../helpers/terminalRequests/regionsList";
import Helpers from "../../../helpers/helperFunctions";
import { createSelector } from "reselect";
import PropTypes from "prop-types";
import { getRegionListSubscriptionData } from "../../../helpers/regionListHelpers";
import { browserHistory } from "react-router";
import Config from "../../../config/main";
import { toggleActiveClassRegion } from "../../../actions/ui";

class RegionsList extends Component {

    constructor (props) {
        super(props);
        this.scroll = this.scroll.bind(this);
    }
    // TODO with Khikar
    // componentWillUnmount () {
    //     console.log('UNMOUNT');
    //     return this.props.dispatch(toggleActiveClassRegion(null));
    // }
    UNSAFE_componentWillReceiveProps (nextProps) {
        let { regionId, gameType, data, sportAlias, competitionId, sportGamesCount } = nextProps;
        // Setting routes and Default Selected Region
        if (data && !regionId && !competitionId) {
            if (gameType !== "live") {
                let selectedRegionId = "all";
                if (sportGamesCount > Config.maxGameLoadCountToSelectRegion) {
                    selectedRegionId = data.regionIds[0];
                }
                browserHistory.push(`/${gameType}/${sportAlias}/${selectedRegionId}/${data.competitionId || "all"}`);
                this.props.dispatch(toggleActiveClassRegion(parseInt(selectedRegionId)));
            } else {
                browserHistory.push(`/${gameType}/${sportAlias}/all/all`);
                this.props.dispatch(toggleActiveClassRegion(null));
            }
        }
    }
    scroll (scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.scrollerRegions.scrollTop += (scrollSize + this.delta);
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

RegionsList.propTypes = {
    data: PropTypes.object,
    loaded: PropTypes.bool,
    selectorKey: PropTypes.string,
    gameType: PropTypes.string,
    regionId: PropTypes.any,
    competitionId: PropTypes.any,
    sportAlias: PropTypes.string,
    timeFilter: PropTypes.number,
    isAsian: PropTypes.bool
};

const mapStateToProps = (state, ownParams) => {
    let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestRegions(ownParams.sportAlias, ownParams.timeFilter, ownParams.isForHashing, ownParams.isAsian, ownParams.gameType));

    return createSelector(
        [
            state => state.swarmData.loaded[key],
            (state, ownProps) => state.swarmData.data[key] && JSON.stringify(getRegionListSubscriptionData(state.swarmData.data[key], ownProps.gameType, ownProps.sportAlias)),
            state => state.uiState.sportGamesCount
            //state => state.swarmData.data[key] && state.swarmData.data[key][0].region[ownParams.regionId]
        ],
        (loaded, data, sportGamesCount) => {
            return {
                loaded,
                data: data && JSON.parse(data),
                selectorKey: key,
                sportGamesCount
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: RegionsList,
    ComponentWillMount: function () {
        let {sportAlias, timeFilter, isAsian, gameType, isForHashing = false} = this.props;
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestRegions(sportAlias, timeFilter, isForHashing, isAsian, gameType);
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestRegions(sportAlias, timeFilter, isForHashing, isAsian, gameType));
        this.meta = {
            simplify: true,
            parseToArray: true,
            sortingFunction: Helpers.byOrderSortingFunc,
            objectToArray: Helpers.objectToArray,
            payloadKey: "sport",
        };
    }
}));